// extracted by mini-css-extract-plugin
export default {"btnSubscribe":"style_btnSubscribe__h5jlV"};